
export default class GameConversationMessage {
    /**
     * @constructor
     * @param {string} sender 
     * @param {string} dialogue 
     * @param {string} action 
     */
    constructor(sender, dialogue, action) {
        this._sender = sender;
        this._dialogue = dialogue;
        this._action = action;
    }

    get sender() {
        return this._sender;
    }

    get dialogue() {
        return this._dialogue;
    }

    get action() {
        return this._action;
    }

    toObject() {
        return {
            sender: this._sender,
            dialogue: this._dialogue,
            action: this._action,
        };
    }

    static fromObject(obj) {
        return new GameConversationMessage(obj.sender, obj.dialogue, obj.action);
    }
}

export const GameMessageSender = {
    PLAYER: 'player',
    COACH: 'coach',
};